import { lazy } from 'react';

const IrCorrectionScreen = lazy(() =>
  import('../pages/IrCorrection/Screens/IrCorrectionScreen'),
);

const irCorrectionRoute = {
  public: [],
  auth: [
    // Intentionally not linked from the nav menu — reachable only by direct URL.
    {
      name: 'ir_correction',
      path: '/ir-correction/tool',
      component: IrCorrectionScreen,
    },
  ],
};

export default irCorrectionRoute;
